function maincontent() {
    const mainContent = document.querySelector('.on_main_content'),
        leftMain = document.querySelector('.left-main'),
        rightMain = document.querySelector('.right-main'),
        mediaMax = window.matchMedia('(min-width: 640px)');

    try {
        if (mediaMax.matches && mainContent.style.display == 'block') {
            leftMain.style.width = '60%';
            rightMain.style.width = '38%';
        }
    } catch(e) {}
}

export default maincontent;